export default __webpack_public_path__ + "static/media/calendar.2561bbfa.svg";